// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * @hidden
 */

var CalendarWeekCellVue2 = {
  props: {
    id: String,
    value: Number
  },
  // @ts-ignore
  emits: {
    'click': null
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },

  /**
   * @return
   * Returns a `<td />` element with the [`value`]({% slug api_dateinputs_calendarweekcellprops %}#toc-value) as a child.
   */
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("td", {
      onClick: this.handleClick,
      on: this.v3 ? undefined : {
        "click": this.handleClick
      },
      id: this.$props.id,
      attrs: this.v3 ? undefined : {
        id: this.$props.id
      }
    }, [this.$props.value !== undefined ? this.$props.value : defaultSlot]);
  },
  methods: {
    handleClick: function handleClick(event) {
      var value = this.$props.value;
      this.$emit('click', value, event);
    }
  }
};
/**
 * @hidden
 */

var CalendarWeekCell = CalendarWeekCellVue2;
export { CalendarWeekCell, CalendarWeekCellVue2 };